module.exports = __webpack_public_path__ + "img/logo.d5635609.png";